export { InputText } from './text';
